export default __webpack_public_path__ + "static/media/map-icon.95057c80.svg";